import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-espresso text-cream py-20 px-6 md:px-12" data-id="element-13">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8" data-id="element-14">
        {/* Brand */}
        <div className="md:col-span-5 flex flex-col items-start" data-id="element-15">
          <Link to="/" className="flex flex-col items-start group mb-6" data-id="element-16">
            <span className="text-3xl font-serif tracking-wide text-ivory" data-id="element-17">
              Aura
            </span>
            <span className="text-[0.65rem] tracking-[0.3em] uppercase text-taupe" data-id="element-18">
              Beauty Atelier
            </span>
          </Link>
          <p className="text-taupe font-light max-w-sm mb-8" data-id="element-19">
            Refined on-site makeup artistry, brow design, and elevated beauty
            services for brides and women who desire elegance, ease, and
            intentional care.
          </p>
          <p className="text-sm tracking-widest uppercase text-champagne" data-id="element-20">
            Charlotte, NC
          </p>
        </div>

        {/* Navigation */}
        <div className="md:col-span-3 flex flex-col gap-4" data-id="element-21">
          <h4 className="text-xs tracking-[0.2em] uppercase text-gold mb-4" data-id="element-22">
            Explore
          </h4>
          <Link to="/" className="text-sm hover:text-white transition-colors" data-id="element-23">
            Home
          </Link>
          <Link to="/about" className="text-sm hover:text-white transition-colors" data-id="element-24">
            About
          </Link>
          <Link to="/bridal-services" className="text-sm hover:text-white transition-colors" data-id="element-25">
            Bridal Services
          </Link>
          <Link to="/beauty-services" className="text-sm hover:text-white transition-colors" data-id="element-26">
            Beauty Services
          </Link>
        </div>

        {/* Contact */}
        <div className="md:col-span-4 flex flex-col gap-4" data-id="element-27">
          <h4 className="text-xs tracking-[0.2em] uppercase text-gold mb-4" data-id="element-28">
            Connect
          </h4>
          <Link to="/contact" className="text-sm hover:text-white transition-colors" data-id="element-29">
            Inquire for Booking
          </Link>
          <a href="https://www.instagram.com/aurabeautyatelierclt?igsh=bDhocmoxcHc2azVv&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" data-id="element-30">
            Instagram @aurabeautyatelierclt
          </a>
          <a href="mailto:aurabeautyatelierclt@gmail.com" className="text-sm hover:text-white transition-colors" data-id="element-31">
            aurabeautyatelierclt@gmail.com
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-taupe/30 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-32">
        <p className="text-xs text-taupe tracking-wider" data-id="element-33">
          © {new Date().getFullYear()} Aura Beauty Atelier. All rights
          reserved.
        </p>
        <p className="text-xs text-taupe tracking-wider" data-id="element-34">
          Luxury brought to you.
        </p>
      </div>
    </footer>;
}